import React from 'react';
import PropTypes from 'prop-types';

import { TopBar } from '@weezevent/nacre';
import Apps from './components/apps';
import Account from './components/account';
import Help from './components/help';
import Organization from './components/organization';
import SwitchEvent from './components/switchEvent';
import Style from './topBarModules.module.css';

export default function TopBarModules({ organization = null, minimal = false, deleteAccount = false }) {
    return (
        <TopBar.Modules className={Style['top-bar-modules']}>
            <SwitchEvent organization={organization} minimal={minimal} />
            <Help organization={organization} />
            <Apps organization={organization} minimal={minimal} />
            <Organization organization={organization} />
            <Account organization={organization} deleteAccount={deleteAccount} />
        </TopBar.Modules>
    );
}

Account.propTypes = {
    organization: PropTypes.object,
    firstEvent: PropTypes.bool
};
